export default __webpack_public_path__ + "static/media/rsDadi.85a1aa17.jpg";